import React from "react";
import Container from "@/components/foundation/Container";
import FadeIn from "@/components/foundation/FadeIn";
import GlowOrb from "@/components/foundation/GlowOrb";
import GridPattern from "@/components/foundation/GridPattern";

export const WhyZenMeSection = () => {
  return (
    <section
      className="relative overflow-hidden py-32 sm:py-40"
      data-testid="why-zenme-section"
    >
      <GridPattern variant="grid" size={80} opacity={0.35} />
      <GlowOrb
        color="emerald"
        size={720}
        intensity={0.16}
        className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      />

      <Container>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <FadeIn>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.02] px-3 py-1 font-mono text-[11px] uppercase tracking-[0.14em] text-brand-emerald">
                <span className="h-1.5 w-1.5 rounded-full bg-brand-emerald shadow-[0_0_8px_rgba(0,230,118,0.7)]" />
                Why ZenMe
              </span>
            </FadeIn>
            <FadeIn delay={0.06}>
              <h2 className="mt-5 font-display text-5xl font-semibold tracking-tight text-white sm:text-6xl">
                Built differently.
              </h2>
            </FadeIn>
          </div>

          <div className="lg:col-span-8">
            <FadeIn delay={0.08}>
              <p className="font-mono text-xs uppercase tracking-[0.14em] text-text-muted">
                Traditional funding asks:
              </p>
            </FadeIn>

            <FadeIn delay={0.14}>
              <p className="mt-2 text-2xl italic text-text-secondary sm:text-3xl">
                &ldquo;What happened last year?&rdquo;
              </p>
            </FadeIn>

            <FadeIn delay={0.22}>
              <p className="mt-10 font-mono text-xs uppercase tracking-[0.14em] text-brand-emerald">
                ZenMe asks:
              </p>
            </FadeIn>

            <FadeIn delay={0.28}>
              <p className="mt-2 font-display text-4xl font-semibold leading-tight text-brand-emerald sm:text-5xl lg:text-6xl text-balance">
                &ldquo;How is your business performing today?&rdquo;
              </p>
            </FadeIn>

            <FadeIn delay={0.4}>
              <p className="mt-10 max-w-2xl text-base leading-relaxed text-text-secondary sm:text-lg">
                Traditional underwriting relies heavily on historical documents
                and static financial snapshots. ZenMe combines AI, live banking
                insights, and structured business data to build a more complete
                understanding of funding readiness — one that recognizes
                momentum, not just history.
              </p>
            </FadeIn>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default WhyZenMeSection;
